import React from 'react';
import { Stack, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import lem_uni from '../../components/assets/lem_uni.png';
import img_uni from '../../components/assets/Illustracion_universitarios.png';
import Carusel from '../../components/Carusel';


const B = styled('span')({
  color: '#268c83',
  fontWeight: 'bold',
});

const Img = styled('img')(({theme}) => ({
  maxWidth: '100%',
  maxHeight: 140,
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: '50%',
  },
}));

const Video = styled('video')({
  maxWidth: '100%',
  maxHeight: `400px`,
});

const images = [
  {
    label: 'Jornadas académicas CDMX',
    description: 'Durante las jornadas académicas, todas las y los seleccionados realizan un breve viaje académico a la Ciudad de México para participar en actividades como conferencias con expertos, talleres, sesiones de diálogo y visitas a las empresas del CMN.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/1-jornadas-academicas.jpg',
  },
  {
    label: 'Jornadas académicas CDMX',
    description: 'Durante las jornadas académicas, todas las y los seleccionados realizan un breve viaje académico a la Ciudad de México para participar en actividades como conferencias con expertos, talleres, sesiones de diálogo y visitas a las empresas del CMN.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/2-jornadas-academicas.jpg',
  },
  {
    label: 'Cursos en línea',
    description: 'Durante el programa, participarás en cursos en línea sobre Innovación y emprendedurismo, Habilidades socioemocionales, Escritura académica e Inglés que te ayudarán a mejorar tus habilidades. ',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/3-cursos-en-linea.jpg',
  },
  {
    label: 'Seminario de Temas Selectos',
    description: 'A través de conferencias de alto nivel y sesiones de diálogo, las y los estudiantes del programa aprenden sobre algunos de los problemas claves de la actualidad.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/4-seminario+de+temas+selectos.jpg',
  },
  {
    label: 'Desafío Práctico',
    description: 'En equipos, las y los participantes trabajan a distancia para proponer una solución a un problema de la vida real.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/5-presentaciones+intermedias.png',
  },
  {
    label: 'Viaje Internacional',
    description: 'Al final del programa, las y los estudiantes participan en un breve viaje académico y cultural en un destino internacional. La primera generación viajó a Brasil, en donde conocieron la Unicamp (Campinas), la Fundação Getúlio Vargas (Sao Paulo) y Universidade do Estado do Rio de Janeiro, entre otros puntos icónicos del país.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/6-viaje-internacional.jpg',
  },
  {
    label: 'Viaje Internacional',
    description: 'Al final del programa, las y los estudiantes participan en un breve viaje académico y cultural en un destino internacional. La segunda generación viajó a Canadá, en donde visitaron la University of British Columbia y la University of Victoria, así como la Ciudad de Vancouver. ',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/7-viaje-internacional.jpg',
  },
  {
    label: 'Testimonios',
    videoPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/Testimoniales+Univesitarios_1.mp4',
  },
];

export default function LemMs() {
  return (
    <Stack
      alignItems="center"
      sx={{
        py: 5,
        px: '5%',
        flexGrow: 1,
        width: '100%',
        boxSizing: 'border-box',
      }}
    > 
      {/* {openA && (
        <Dialog onClose={() => setOpenA(false)} open={openA}>
          <DialogTitle>Anuncio Etapa 1</DialogTitle>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenA(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Stack p={3}>
            ¡Gracias a quienes participaron en la Etapa 1 de Líderes en Movimiento Universitarios! 
            Si completaste el registro y cumples con los requisitos, podrás acceder a las pruebas de 
            la Etapa 2 del 6 al 10 de marzo. Inicia sesión en: <a href="https://lem.learnala.com/login">https://lem.learnala.com/login</a>
          </Stack>
        </Dialog>
      )} */}
      <Stack  sx={{ maxWidth: '1200px', width: '100%', boxSizing: 'border-box' }}>
        <Stack direction="row" justifyContent="space-between">
          <Img src={lem_uni} alt="Líderes en Movimiento Universitarios" />
          <Img src={img_uni} alt="Líderes en Movimiento Universitarios" />
        </Stack>
        <Stack spacing={2} mb={2}>
          <Stack direction="row" justifyContent="space-around" sx={{ mt: 2}}>
            <Box sx={{ textAlign: 'justify' }}>
            <B>Líderes en Movimiento (LeM) Universitarios</B> es un programa extracurricular que busca estudiantes con mentes
            abiertas, un alto sentido ético, iniciativa de liderazgo social, interés por mejorar
            su entorno y disposición por esforzarse y aprender.
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-around" sx={{ mt: 2}}>
            <Box sx={{ textAlign: 'justify' }}>
            A lo largo de seis años y cinco ediciones de <B>Líderes en Movimiento</B>,
            han participado de manera gratuita <B>460 estudiantes universitarios</B> provenientes
            de todo el país, de todas las áreas del conocimiento y de todos los estratos sociales.
            </Box>
          </Stack>
          <Stack sx={{ color: '#cb912f', fontWeight: 'bold' }}>
            ¡Conoce algunos de los testimonios y primeros resultados de este programa!
          </Stack>
        </Stack>
        <Video id="video_U1" src={"https://s3.amazonaws.com/lideresenmovimiento.s3/que+es+lem+U.mp4"} controls autoPlay playsInline muted loop />
        {/* <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2, mb: 1 }}>Testimonios</Box> */}
        {/* <Video id="video_U" src={"https://s3.amazonaws.com/lideresenmovimiento.s3/testimoniales_univesitarios.mp4"} controls autoPlay playsInline muted loop /> */}
        {/* <Requisitos />
        <Image
          sx={{ maxWidth: '1200px', objectFit: 'contain' }}
          mt={2}
          src="https://s3.amazonaws.com/lideresenmovimiento.s3/ComponentesU_REDONDO.png"
          alt="Componentes Universitarios"
          allowFullScreen
        /> */}
        {/* <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2 }}>Convocatoria</Box>
        {buttons.map((button) => (
          <Button key={`file${button.id}`} sx={{ mt: 2 }} variant="outlined" onClick={() => handleOpenFile(button)}>{button.label}</Button>
        ))}
        <Button sx={{ mt: 2 }} variant="contained" onClick={handleGoToApplication}>Regístrate aquí</Button> */}
        <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2 }}>Carrusel de Fotos</Box>
        <Carusel images={images} />
      </Stack>
    </Stack>
  );
}
